import { Chip } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DirectionEnum, IPassengerInfo, IStationInfo } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";

export type TStationInfoWithOrderIndex = IStationInfo & { orderIndex: number };

interface IPassengerStationsProps {
  stationFromInfo: TStationInfoWithOrderIndex;
  stationToInfo: TStationInfoWithOrderIndex;
  passenger: IPassengerInfo;
  direction?: DirectionEnum;
}

export const PassengerStations: FC<IPassengerStationsProps> = ({
  stationFromInfo,
  stationToInfo,
  passenger,
  direction,
}) => {
  // Station labels are 1-based, matching the numbering the ride map draws on its pins.
  const waypointFromIndex = stationFromInfo.orderIndex + 1;
  const waypointToIndex = stationToInfo.orderIndex + 1;
  const { t } = useTranslation();
  const label =
    direction === DirectionEnum.DropOff
      ? `${waypointToIndex}`
      : `${waypointFromIndex}`;
  const tooltipContent = `${passenger.firstName} | ${t("ride.FROM")}: ${stationFromInfo.name} (${waypointFromIndex}) | ${t("ride.TO")}: ${stationToInfo.name} (${waypointToIndex})`;

  return (
    <FramerTooltip content={tooltipContent}>
      <Chip
        size="small"
        label={label}
        sx={{ fontSize: "10px", height: "1.5em" }}
      />
    </FramerTooltip>
  );
};
